var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-action-container"},[(_vm.renderComponent)?_c('div',{staticClass:"loader-content"},[_c('h2',[_vm._v(_vm._s(_vm.event.title)+" is currently processing.")]),_c('p',[_vm._v("This usually takes 15-45 minutes")]),_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('i'),_c('i'),_c('i'),_c('i')])
}]

export { render, staticRenderFns }